<template>
  <validation-provider :rules="validations" v-slot="{ errors }">
    <v-text-field
      :value="value"
      :label="field.label"
      :disabled="readonly"
      @change="onChange"
      :outlined="outlined"
      :error-messages="errors"
      color="#005c7b"
    ></v-text-field>
  </validation-provider>
</template>

<script>
export default {
  props: ["field", "value", "readonly", "outlined", "validations"],
  methods: {
    onChange: function (event) {
      this.$emit("fieldChange", event);
    },
  },
};
</script>
